import Tool, { type ToolArgsWithController } from '../../../tools/Tool';
import aiIconSvg from '../../../assets/icons/aiIcon.svg';

class ToolWritingAssistant extends Tool {
  static toolName = 'AI assistant';
  static iconSvg = aiIconSvg;

  static available({ controller }: ToolArgsWithController): boolean {
    // Technically the writing assistant also relies on the fullscreen provider
    return (
      controller.ahaEditor.hasProvider('writingAssistant') &&
      controller.ahaEditor.hasProvider('fullScreen')
    );
  }

  static isEnabled({ controller }: ToolArgsWithController): boolean {
    return (window as any).currentUser?.hasAiAssistant || false;
  }

  static tooltip(toolArgs: ToolArgsWithController): string {
    return (window as any).currentUser?.hasAiAssistant
      ? this.ariaLabel
      : 'The AI assistant is only for paid users';
  }

  static async action({ controller }: ToolArgsWithController) {
    const provider = controller.ahaEditor.getProvider('writingAssistant');
    provider?.openWritingAssistant();
  }
}

export default ToolWritingAssistant;
